import { getCookie } from '../storageUtils';
import { TIME_ZONE_KEY, DEFAULT_LOCALE, DEFAULT_TIME_ZONE } from './constants';
var timeZoneCookie = getCookie(TIME_ZONE_KEY);
export var activeLocale = process.env.locale || DEFAULT_LOCALE;
export var appTimeZone = typeof window !== 'undefined' && window[TIME_ZONE_KEY] || (timeZoneCookie && typeof timeZoneCookie === 'string' ? timeZoneCookie : null) || DEFAULT_TIME_ZONE;
/**
 * Dynamically import given locale
 * @param {string} locale
 */

export var dynamicLocaleImport = function dynamicLocaleImport(locale) {
  var localePath = "date-fns/locale/".concat(locale);

  var reqLocale = require("".concat(localePath)); // eslint-disable-line


  return reqLocale;
};